import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { getAxiosConfig } from '../utils/http'

// Address validation
export const validateUSPSAddress = createAsyncThunk(
  'shipping/validateUSPSAddress',
  async (
    { address1, address2, city, postalCode, state: stateCode, country },
    thunkAPI
  ) => {
    try {
      // Avoid shadowing the address `state` by naming the root store `rootState`.
      const rootState = thunkAPI.getState();
      const config = getAxiosConfig(rootState, {
        headers: { 'Content-Type': 'application/json' },
      });
      const { data } = await axios.post('/api/shipping/shippingaddress', {
        address1,
        address2,
        city,
        postalCode,
        state: stateCode,
        country,
      }, config)
      return data
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      )
    }
  }
)

// Shipping rate fetch
export const getUSPSRates = createAsyncThunk(
  'shipping/getUSPSRates',
  async (postalCode, thunkAPI) => {
    try {
      const state = thunkAPI.getState();
      const config = getAxiosConfig(state);
      const { data } = await axios.get(`/api/shipping/${postalCode}`, config)
      return data
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      )
    }
  }
)

const shippingSlice = createSlice({
  name: 'shipping',
  initialState: {
    loadingAddress: false,
    loadingRates: false,
    shippingAddressRes: null,
    rates: null,
    errorAddress: null,
    errorRates: null,
  },
  reducers: {
    resetShippingState: (state) => {
      state.loadingAddress = false
      state.loadingRates = false
      state.shippingAddressRes = null
      state.rates = null
      state.errorAddress = null
      state.errorRates = null
    },
  },
  extraReducers: (builder) => {
    builder
      // Address
      .addCase(validateUSPSAddress.pending, (state) => {
        state.loadingAddress = true
        state.errorAddress = null
      })
      .addCase(validateUSPSAddress.fulfilled, (state, action) => {
        state.loadingAddress = false
        state.shippingAddressRes = action.payload
      })
      .addCase(validateUSPSAddress.rejected, (state, action) => {
        state.loadingAddress = false
        state.errorAddress = action.payload
      })
      // Rates
      .addCase(getUSPSRates.pending, (state) => {
        state.loadingRates = true
        state.errorRates = null
      })
      .addCase(getUSPSRates.fulfilled, (state, action) => {
        state.loadingRates = false
        state.rates = action.payload
      })
      .addCase(getUSPSRates.rejected, (state, action) => {
        state.loadingRates = false
        state.errorRates = action.payload
      })
  },
})

export const { resetShippingState } = shippingSlice.actions
export default shippingSlice.reducer
